import React, { useEffect, useRef, useState } from 'react';
import { useGlobalContext } from '../../js/context';
import { tns } from 'tiny-slider/src/tiny-slider';
import MenuPageAnime from './MenuPageAnime';
import { gtmTracking } from '../../js/helpers';
import './MenuPage.scss'
import ReactGA from 'react-ga4'

const MenuPage = () => {
  const { products, isMobile, productClickHandler } = useGlobalContext();
  const sliderRef = useRef();
  const [currentSlide, setCurrentSlide] = useState(1);
  const subTitleText =
    'This tool allows you to compare the difference between cigarettes and our heated tobacco product.';
    
  const disclamerText = `A reduction in levels does not necessarily equate to a reduction in risk. Our heated
    tobacco product is not risk-free and contains nicotine, which is
    addictive. Average levels over nine tests. Simulation not to scale.
    For illustrative purposes only. "Our heated tobacco product" refers
    to <em><i>IQOS ILUMA</i></em>.`;

  useEffect(() => {
    ReactGA.send({hitType: "pageview", page: "MenuPage", title: "MenuPage"})
    MenuPageAnime();

    if (sliderRef.current) {
      let slider = tns({
        container: sliderRef.current,
        items: 2,
        autoplay: false,
        center: true,
        swipeAngle: false,
        controlsContainer: '#tos-menu__slider-controler',
        prevButton: '#tos-menu__slider-prev',
        nextButton: '#tos-menu__slider-next',
        responsive: {
          800: {
            disable: true,
          },
        },
        onInit(info) {
          info.controlsContainer.setAttribute('tabindex', -1);
          info.nextButton.setAttribute('tabindex', 0);
          info.prevButton.setAttribute('tabindex', 0);
        },
      });

      const customizedFunction = function (info) {
        setCurrentSlide(info.displayIndex);
      };

      slider.events.on('transitionEnd', customizedFunction);

      if (isMobile) {
        slider.refresh();
      } else {
        slider = null;
      }
    }
  }, [isMobile]);

  return (
    <div className='tos-menu tos-hide-before-animated'>
      {isMobile && (
        <div className='tos-menu__content'>
          <h2 className='tos-menu__title tos-font-big tos-hide-before-animated'>
            List of inhalable harmful and potentially harmful constituents
          </h2>
          <p className='tos-menu__paragraph tos-hide-before-animated'>
            {subTitleText}
          </p>
          <small
            dangerouslySetInnerHTML={{
              __html: `${disclamerText}`,
            }}
          />
        </div>
      )}
      <div className='tos-slider__wrapper'>
        {isMobile && (
          <div className='tos-menu__slider-pagination tos-hide-before-animated'>
            <span>{currentSlide}</span> / {products.length}
          </div>
        )}
        <div className='tos-menu__slider-wrapper'>
          <ul className='tos-menu__lists' id='tos-menu__lists' ref={sliderRef}>
            {products.map((product) => (
              <li key={product.id}>
                <button
                  onClick={() => {
                    productClickHandler(product.name);
                    gtmTracking('component grid', product.name);
                  }}
                  className={`tos-menu__lists-button ${
                    product?.name.length >= 17
                      ? 'tos-menu__lists-button--large'
                      : ''
                  } ${
                    product?.name.length > 20
                      ? 'tos-menu__lists-button--Xlarge'
                      : ''
                  }`}
                >
                  {product.name}
                  {product.sub_title && (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: product.sub_title,
                      }}
                    />
                  )}
                  <small>
                    COMPARE
                    <svg
                      width='16'
                      height='17'
                      viewBox='0 0 16 17'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M3 8.5H12.5M12.5 8.5C12.5 8.5 9.86683 5.86683 8.5 4.5M12.5 8.5C12.5 8.5 9.86683 11.1332 8.5 12.5'
                        stroke='#0074C2'
                      />
                    </svg>
                  </small>
                </button>
              </li>
            ))}
            {!isMobile && (
              <>
                <div className='tos-menu__largeBlock tos-hide-before-animated'>
                  <h2>
                    List of inhalable harmful and potentially harmful
                    constituents
                  </h2>
                  <div className='tos-menu__largeBlock-content'>
                    <p>{subTitleText}</p>
                    <small
                      dangerouslySetInnerHTML={{
                        __html: `${disclamerText}`,
                      }}
                    />
                  </div>
                </div>
                <div className='tos-menu__smallBlock tos-hide-before-animated'>
                  <h2>Click on one constituent to start exploring.</h2>
                </div>
              </>
            )}
          </ul>
        </div>
        <div
          className='tos-menu__slider-controler'
          id='tos-menu__slider-controler'
        >
          <button
            className='tos-menu__slider-button tos-hide-before-animated'
            id='tos-menu__slider-prev'
          >
            <svg
              width='10'
              height='15'
              viewBox='0 0 10 15'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.95 7.5L8.42319 15L9.5 13.9202L3.05557 7.48296L9.48294 1.06275L8.42319 -9.41378e-08L0.95 7.5Z'
                fill='white'
              />
            </svg>
          </button>
          <button
            className='tos-menu__slider-button tos-hide-before-animated'
            id='tos-menu__slider-next'
          >
            <svg
              width='10'
              height='15'
              viewBox='0 0 10 15'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.05 7.5L1.57681 0L0.5 1.0798L6.94443 7.51704L0.517062 13.9372L1.57681 15L9.05 7.5Z'
                fill='white'
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuPage;
